$(document).ready(function () {
  $(document).on('click', '.remove_fields', function (event) {
    $(this).prev('input[type=hidden]').val('1');
    $(this).closest('section').hide();
    return event.preventDefault();
  });
  $(document).on('click', '.add_form_fields', function (event) {
    var regexp, time;
    time = new Date().getTime();
    regexp = new RegExp($(this).data('id'), 'g');
    $(this).before($(this).data('fields').replace(regexp, time));
    return event.preventDefault();
  });

});
